import script from "./InfoBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoBar.vue?vue&type=script&lang=ts&setup=true"

import "./InfoBar.vue?vue&type=style&index=0&id=5e3d217c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3d217c"]])

export default __exports__